module.exports = __webpack_public_path__ + "media/images/metronic/social/xing-55fbd6a3319d49e4bf046dd4a80b59a1.png";